module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    staticClass: "mb-5",
    attrs: {
      "action": "index.html",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group p-3"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "password-input"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "group"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-outline-info btn-lg",
    attrs: {
      "to": "/profile"
    }
  }, [_vm._v("キャンセル")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-lg",
    class: _vm.submitStyle,
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_vm._v("メールアドレス変更")])], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "text-right mt-5"
  }, [_c('router-link', {
    attrs: {
      "to": "/mypage"
    }
  }, [_vm._v("マイページへのリンク")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('small', [_vm._v("メールアドレス変更")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "alert alert-info"
  }, [_vm._v("入力頂いたメールアドレス宛に、確認のメールをお送りさせて頂きます。メール内にあるURLをクリックすると変更が完了します。"), _c('br'), _vm._v(" メールアドレス変更完了後は、ログイン用のメールアドレスも変更となりますので、ご注意下さい。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-form-label",
    attrs: {
      "for": "password-input"
    }
  }, [_vm._v("新しいメールアドレス"), _c('span', {
    staticClass: "attention"
  }, [_vm._v("※")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a859c314!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lecturer/profile/EditEmail.vue
// module id = 353
// module chunks = 1